import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NGXLogger } from 'ngx-logger';
import { handleResponse } from 'src/functions/http-handler';
import { PrintService } from './print.service';
import { FileSaverService } from 'ngx-filesaver';
import { environment } from 'src/environments/environment';
import { IPagedList } from 'src/models/paged-list.model';

const PRINT_TITLE = '불량 발생 내역';

@Injectable({
  providedIn: 'root'
})
export class DefectManagementService {
  private _apiUrl: string;

  constructor(
    @Inject(HttpClient) protected http: HttpClient,
    @Inject('BASE_URL') baseUrl: string,
    private fileSaver: FileSaverService,
    private printSvc: PrintService,
    private logger: NGXLogger) {
    this._apiUrl = `${baseUrl}api/DefectManagement`;
  }

  get(param: any) {
    return this.http.get(this._apiUrl, { params: param })
      .pipe(handleResponse<IPagedList<IDefectManagement>>(this.logger, 'retrieve defect-management'));
  }

  print(param: any) {
    let title = document.createElement('h2');
    title.innerText = PRINT_TITLE;
    return this.printSvc.print(this.http, `${this._apiUrl}/Print`, param, title);
  }

  export(param: any, type: 'sheet' | 'pdf') {
    const mimeType = (type == 'sheet') ? environment.mimeTypes.excel : environment.mimeTypes.pdf;
    const extension = (type == 'sheet') ? '.xlsx' : '.pdf';

    return this.http.get(`${this._apiUrl}/Export`, {
      headers: { 'Accept': mimeType },
      responseType: 'blob', // This must be a Blob type
      params: param
    }).subscribe((res: Blob) => {
      var filename = `DefectManagement${extension}`;
      this.saveAsBlob(res, filename, mimeType);
    })
  }

  private saveAsBlob(data: any, filename: string, mimeType: string) {
    const file = new File([data], filename, { type: mimeType });
    this.fileSaver.save(file, filename);
  }
}

export interface IDefectManagement {
  /*
  procurementType: string,
  type: string,
  itemId: string,
  itemName: string,
  unit: string,
  quantity: number,
  purchasePrice: number,
  amount: number,
  currency: string,
  description: string,
  */
  gubun: string,              //원천
  vendAccount: string,        //구매처
  vendName: string,           //구매처명
  nonDate: Date,              //불량발생일자
  itemId: string,             //품번
  itemName: string,           //품명
  unitId: string,             //단위
  testDefectQty: number,      //불량수량
  purchPrice: number,         //단가
  totalPrice: number,         //금액
  currency: string,           //통화
  typeId: string,             //불량내역
  nonType: string,            //검사유형
  inventSiteId: string,       //플랜트
  tymAqlType: string,         //검사엄격도
}
